import React from 'react';
import * as S from './ErrorCard.styles';

const ErrorCard = ({src, errorTxt, errorSubtext, errorImgClass}) => {
  return (
    <S.ErrorCardContainer>
      <div className="makeFlex perfectCenter dirColumn">
        <img src={src} className={errorImgClass}></img>
        <p className="font20 lineHeight24 latoBlack width328 textCenter">{errorTxt}</p>
        <p className="font14 lineHeight20 secondaryTxt appendTop8 width328 textCenter">
          {errorSubtext}
        </p>
      </div>
    </S.ErrorCardContainer>
  );
};

export default ErrorCard;
